(() => {
  window.addEventListener("abra:announced", () => {
    document
      .querySelectorAll(".multi-collection__tab-group button")
      .forEach((button) => {
        button.addEventListener("click", () => {
          setTimeout(() => {
            window.dispatchEvent(new CustomEvent("abra:render"));
          }, 500);
        });
      });
  });

  const customer = fetchCustomer();

  if (
    customer &&
    customer.tags &&
    customer.tags.length > 0 &&
    customer.tags.includes("Trade")
  ) {
    window.Abra.deactivate(false);
  }

  function fetchCustomer() {
    try {
      const scriptElement = document.getElementById("AbraCustomer");

      if (scriptElement && scriptElement.textContent) {
        try {
          return JSON.parse(scriptElement.textContent);
        } catch (err) {
          console.log(err);
        }
      }
    } catch (err) {
      console.log(err);
    }

    return undefined;
  }
})();

(() => {
  'use strict';

  const ensureProductSaleBadge = (el) => {
    if (el.querySelector('.usf-sale-badge')) return;

    const badge = document.createElement('div');
    badge.className = 'usf-badge usf-sale-badge';
    badge.style.display = 'none';

    if (el.classList.contains('usf-grid__item')) {
      const imgWrapper = el.querySelector('.usf-grid__item-link > .usf-img-wrapper');
      if (imgWrapper) imgWrapper.insertAdjacentElement('afterend', badge);
    } else {
      const imgWrapper = el.querySelector('.usf-img-column .usf-img-wrapper');
      if (imgWrapper) imgWrapper.appendChild(badge);
    }
  };

  const applyHandles = () => {
    document.querySelectorAll('.usf-sr-product').forEach(el => {
      const vue = el.__vue__;
      if (!vue || !vue.product) return;

      const handle = vue.product.urlName;
      el.setAttribute('data-product-handle', handle);

      el.querySelectorAll('.usf-price-wrapper').forEach(pw => {
        pw.setAttribute('data-product-handle', handle);
      });

      ensureProductSaleBadge(el);
    });

    document.querySelectorAll('.usf-is-product').forEach(el => {
      const vue = el.__vue__;
      if (!vue || !vue.product) return;

      const handle = vue.product.urlName;
      el.setAttribute('data-product-handle', handle);

      el.querySelectorAll('.usf-price-wrapper').forEach(pw => {
        pw.setAttribute('data-product-handle', handle);
      });
    });

    window.Abra && window.Abra.render();
  };

  const ensurePreviewSaleBadge = (container) => {
    const contentLeft = container.querySelector('.usf-preview__content-left');
    if (!contentLeft) return;

    const existing = contentLeft.querySelector('.usf-preview__badge-sale');
    if (existing) return;

    const badge = document.createElement('div');
    badge.className = 'usf-preview__badge usf-preview__badge-sale';
    badge.style.display = 'none';
    contentLeft.appendChild(badge);
  };

  const dispatchPreviewOpen = (handle, container) => {
    console.log('[abra] dispatchPreviewOpen called', { handle, container });

    window.dispatchEvent(new CustomEvent('usf:preview-open', {
      bubbles: true,
      detail: {
        handle,
        container,
        product: container.__vue__ && container.__vue__.product || null
      }
    }));

    console.log('[abra] usf:preview-open dispatched — scheduling Abra.render()');

    setTimeout(() => {
      console.log('[abra] Abra.render() called after usf:preview-open');
      window.Abra && window.Abra.render();
    }, 0);
  };

  const watchPreviewModal = () => {
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue;

          const container = node.classList.contains('usf-preview__container')
            ? node
            : node.querySelector('.usf-preview__container');

          if (!container) continue;

          console.log('[abra] .usf-preview__container detected in DOM', container);

          const getHandle = () => {
            const vueRoot = container.closest
              ? container.closest('body > div')
              : node;
            const vue = vueRoot && vueRoot.__vue__;

            console.log('[abra] vueRoot:', vueRoot, '__vue__:', vue, 'product:', vue && vue.product);

            if (vue && vue.product && vue.product.urlName) {
              return vue.product.urlName;
            }

            const link = container.querySelector('a.usf-preview__link, .usf-preview__title a');
            if (link) {
              const match = (link.getAttribute('href') || '').match(/\/products\/([^?/]+)/);
              if (match) return match[1];
            }
            return null;
          };

          setTimeout(() => {
            const handle = getHandle();
            console.log('[abra] handle resolved:', handle);

            if (!handle) return;

            container.setAttribute('data-product-handle', handle);
            container.querySelectorAll('.usf-preview__price-wrapper').forEach(pw => {
              pw.setAttribute('data-product-handle', handle);
            });

            ensurePreviewSaleBadge(container);
            dispatchPreviewOpen(handle, container);
          }, 50);
        }
      }
    }).observe(document.body, { childList: true, subtree: false });
  };

  const init = () => {
    if (!window.usf || !usf.event) {
      setTimeout(init, 100);
      return;
    }

    usf.event.add(['sr_updated', 'sr_viewChanged', 'rerender'], () => {
      setTimeout(applyHandles, 0);
    });

    usf.event.add('is_updated', () => {
      setTimeout(applyHandles, 0);
    });
  };

  watchPreviewModal();
  init();
})();
